import { createRouter } from "@tanstack/react-router";

import { routeTree } from "@/routeTree.gen";

import type { CrumbDef } from "./crumb-types";
import { queryClient } from "./query-client";

export const router = createRouter({
  routeTree,
  context: { queryClient, auth: { user: null } },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  /*
   * **`scrollRestoration: true` は入れない。**
   * これを有効にすると、ルーターが window だけでなく**入れ子の要素のスクロール位置まで**
   * 記録・復元する（sessionStorage 経由でリロードもまたぐ）。
   * 利用申込フォームの規約同意は「一度下端まで読んだか」で判定しており
   * （`features/apply/scroll-to-agree.tsx`）、枠のスクロール位置が復元されると
   * **規約を表示しないまま同意できる状態**になる。
   * ページ先頭への移動が要る画面は、そのページ側で明示的に行う。
   */
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
  /**
   * 各ルートの `staticData.crumb` を AutoBreadcrumb が `useMatches()` で集めて描画する。
   * optional にしているのは、root / `_authenticated` など crumb を持たないルートがあるため。
   * 「全 leaf に crumb がある（または親 layout が provide する）」ことは
   * `src/__tests__/route-crumbs.test.ts` で機械的に検証している。
   */
  interface StaticDataRouteOption {
    crumb?: CrumbDef;
  }
}
